<template>
  <ion-app>
    <global-menu />
    <ion-router-outlet />
    <cookie-consent-banner />
  </ion-app>
</template>

<script setup lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import GlobalMenu from './components/GlobalMenu.vue';
import CookieConsentBanner from './components/CookieConsentBanner.vue';
</script>
